import axios, { AxiosInstance } from 'axios';

// Vite exposes env vars via import.meta.env (must be prefixed with VITE_)
const BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4500/api';

export interface SharedPhotoMetadata {
  tagsSnapshot: string[];
  takenAt?: string;
  createdAt: string;
}

/**
 * Plain, unauthenticated HTTP client for the public share page.
 * Deliberately does NOT reuse HTTPService: that client carries cookies and
 * has interceptors that clear the signed-in user or reload the page on
 * 401/403, which is wrong behavior for an anonymous visitor hitting an
 * invalid/revoked share token.
 */
export class ShareService {
  private httpClient: AxiosInstance;

  constructor() {
    this.httpClient = axios.create({ baseURL: BASE_URL });
  }

  async getSharedPhoto(token: string): Promise<SharedPhotoMetadata> {
    const response = await this.httpClient.get<SharedPhotoMetadata>(`/share/${token}`);
    return response.data;
  }
}

export const shareService = new ShareService();
